import React, { forwardRef } from 'react';
import { Button } from 'antd';

const BaseClearInput = (props) => {
  const { label, labelStyle, readonly, width, textValue, onClick, ...rest } =
    props;

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: width || '100%',
      height: '5.8rem',
      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    label: {
      display: 'flex',
      height: '2rem',
      alignItems: 'center',
      // font
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
      // color: 'black',
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '3.5rem',
      padding: 0,
      border: '1px solid #DBDADE',
      borderRadius: 6,
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      height: '3.8rem',
      width: '100%',
      padding: '0rem 1rem 0rem 1rem',
      background: 'transparent',

      // font
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
    },
  };

  return (
    <div style={{ ...styles.container }}>
      <div style={{ ...styles.label, ...labelStyle }}>{label}</div>
      <div style={{ ...styles.row, marginTop: 4 }}>
        <div style={{ ...styles.text }}>{textValue}</div>
        <Button
          shape="circle"
          style={{ padding: 0, border: 0, margin: 0, width: 24, height: 24 }}
          icon={
            <img
              style={{ padding: 0, border: 0, margin: 0 }}
              width={24}
              height={24}
              src={require('../../assets/images/ico_circle_x.png')}
            />
          }
          onClick={(e) => {
            onClick(e);
          }}
        />
      </div>
    </div>
  );
};

export default forwardRef(BaseClearInput);
